/* eslint-disable import/no-cycle */
import { put, takeEvery } from "redux-saga/effects";
import { enqueueSnackbar } from "notistack";
import { teamsAction } from "../slice/teams";
import { fetchTeamList, fetchTeamsList } from "../../apis/team";

export function* getTeamsList({ payload }) {
  try {
    const teams = yield fetchTeamsList(payload);

    if (teams?.data?.success) {
      yield put(
        teamsAction.getTeams({
          teams: teams.data.data.teams,
          totalTeams: teams.data.data.count,
          ...(payload?.searchBy ? {} : { allTeams: teams.data.data.allTeams }),
        })
      );
    } else if (teams?.response?.status !== 403) {
      enqueueSnackbar(
        JSON.stringify({
          icon: "error",
          title: "Error",
          text: teams?.response?.data?.message || "Something went wrong",
        }),
        {
          variant: "custom",
        }
      );
      yield put(teamsAction.getTeamsFail());
    }
  } catch (error) {
    enqueueSnackbar(
      JSON.stringify({
        icon: "error",
        title: "Error",
        text: error?.response?.data?.message || error.message || "Something went wrong",
      }),
      {
        variant: "custom",
      }
    );
    yield put(teamsAction.getTeamsFail());
  }
}

export function* getTeamMemberList({ payload }) {
  try {
    const team = yield fetchTeamList(payload);

    if (team?.data?.success) {
      yield put(
        teamsAction.getTeam({ data: team.data.data.members, totalMembers: team.data.data.count })
      );
    } else if (team?.response?.status === 404) {
      enqueueSnackbar(
        JSON.stringify({
          icon: "error",
          title: "Error",
          text: team?.response?.data?.message || "Something went wrong",
        }),
        {
          variant: "custom",
        }
      );
      payload.navigateFunction("/teams");
      yield put(teamsAction.getTeamFail());
    } else if (team?.response?.status !== 403) {
      enqueueSnackbar(
        JSON.stringify({
          icon: "error",
          title: "Error",
          text: team?.response?.data?.message || "Something went wrong",
        }),
        {
          variant: "custom",
        }
      );
      yield put(teamsAction.getTeamFail());
    }
  } catch (error) {
    enqueueSnackbar(
      JSON.stringify({
        icon: "error",
        title: "Error",
        text: error?.response?.data?.message || error.message || "Something went wrong",
      }),
      {
        variant: "custom",
      }
    );
    yield put(teamsAction.getTeamFail());
  }
}

export function* watchTeamsAsync() {
  yield takeEvery(teamsAction.getTeamsSaga, getTeamsList);
  yield takeEvery(teamsAction.getTeamSaga, getTeamMemberList);
}
